<template>
    <div class="app-container">
        <Header title="车辆定位" showBack></Header>

        <EtaDisplay :route-info="routeInfo" @recalculate-route="handleRecalculateRoute" />

        <MapContainer ref="mapContainer" :vehicle-gid-list="vehicleGidList" :vehicle-position="vehiclePosition"
            :node-geocoder="nodeGeocoder" :self-position="selfPosition" :should-update-route="shouldUpdateRoute"
            @vehicle-position-updated="handleVehiclePositionUpdate" @self-position-updated="handleSelfPositionUpdate"
            @route-updated="handleRouteUpdate" @route-error="handleRouteError" />
    </div>
</template>

<script>
import MapContainer from '@/components/Map/MapContainer.vue';
import EtaDisplay from '@/components/Map/EtaDisplay.vue';
import Header from "@/components/Header/Header.vue";
export default {
    name: 'App',
    components: {
        MapContainer,
        EtaDisplay,
        Header
    },
    data() {
        return {
            vehicleGidList: this.$route.query.VehicleGIDList,
            nodeGeocoder: this.$route.query.NodeGeocoder,
            vehiclePosition: { lng: 116.397428, lat: 39.90923 }, // 默认车辆位置
            selfPosition: { lng: this.$route.query.NodeGeocoder.split(",")[0], lat: this.$route.query.NodeGeocoder.split(",")[1] },
            routeInfo: null,
            shouldUpdateRoute: false, // 控制是否更新路线
        };
    },
    methods: {
        handleVehiclePositionUpdate(position) {
            this.vehiclePosition = position;
            this.shouldUpdateRoute = false;
        },
        handleRecalculateRoute() {
            // 手动触发路线更新
            this.shouldUpdateRoute = true;
            this.$nextTick(() => {
                this.shouldUpdateRoute = false; // 重置状态
            });
        },
        handleSelfPositionUpdate(position) {
            this.selfPosition = position;
        },
        handleRouteUpdate(routeInfo) {
            this.routeInfo = routeInfo;
        },
        handleRouteError(error) {
            console.error('路线规划错误:', error);
            // 可以在这里添加错误处理逻辑，如显示错误提示
        }
    }
};
</script>



<style scoped>
* {
    margin: 0;
    padding: 0;
}

html,
body,
#app {
    width: 100%;
    height: 100%;
}

.app-container {
    width: 100%;
    height: 100%;
    position: relative;
}
</style>